export const DEFAULT_SIZE = 21; // GNB 에서 사용하는 사이즈
